//MapTips_Custom.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as Custom from "../Custom";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { Typography } from "@mui/material";

import React from "react";

//Build the map tip.
export function getMapTip(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: Default.iStyles = {
      parcels: { maxHeight: 250, maxWidth: 350, overflow: 'auto' },
      default: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
   };

   //Parcels.
   if (mapTipSetting.layerName === "Parcels") {
      jsx.push(<div key={Util.uid()} style={styles.parcels} title={mapTipSetting.layerName}>
         {getParcels(fields)}
      </div>);

   } else { //Default map tip.
      jsx.push(<div key={Util.uid()} style={styles.default} title={mapTipSetting.layerName}>
         {getDefault(mapTipSetting, fields)}
      </div>);
   }
   return jsx;
}

//Parcels.
export function getParcels(fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: any = {
      black: { color: 'black', fontWeight: 500 },
      red: { color: 'darkred', fontWeight: 500 },
      green: { color: 'green', fontWeight: 500 },
   };

   let pin: string;
   let siteAddress: string;
   let beds: number;
   let baths: number;
   let sqFt: any;
   let mrkLand: any;
   let mrkImp: any;
   let mrkTotal: any;
   let pictureLinks: string;
   let sketchLinks: string;

   for (const field of fields) {
      if (field.name.Equal("pin")) {
         pin = field.value;

      } else if (field.name.Equal("siteAddress")) {
         siteAddress = field.value;

      } else if (field.name.Equal("Bedrooms")) {
         beds = field.value;

      } else if (field.name.Equal("Bathrooms")) {
         baths = field.value;

      } else if (field.name.Equal("SqFt")) {
         sqFt = field.value;

      } else if (field.name.Equal("MarketValue_Land")) {
         mrkLand = field.value;

      } else if (field.name.Equal("MarketValue_Improvement")) {
         mrkImp = field.value;

      } else if (field.name.Equal("MarketValue_Total")) {
         mrkTotal = field.value;

      } else if (field.name.Equal("PictureLinks")) {
         pictureLinks = field.value;

      } else if (field.name.Equal("SketchLinks")) {
         sketchLinks = field.value;
      }
   }

   jsx.push(<div key={Util.uid()}>
      <span>Market Land:&nbsp;</span><span style={styles.black}>{mrkLand}</span>
      <span>&nbsp;&nbsp;Imp:&nbsp;</span><span style={styles.black}>{mrkImp}</span>
      <span>&nbsp;&nbsp;Tot:&nbsp;</span><span style={styles.black}>{mrkTotal}</span>
      <br />

      <span style={styles.red}>{beds}</span><span>&nbsp;Beds&nbsp;&nbsp;</span>
      <span style={styles.red}>{baths}</span><span>&nbsp;Baths&nbsp;&nbsp;</span>
      <span style={styles.red}>{sqFt}</span><span>&nbsp;SqFt&nbsp;&nbsp;&nbsp;</span>

      <span style={styles.green}>{siteAddress}</span>
   </div>);

   let fsLinks: string[];
   fsLinks = Custom.addToLinks(pictureLinks, fsLinks);
   fsLinks = Custom.addToLinks(sketchLinks, fsLinks);

   for (const url of fsLinks) {
      jsx.push(<img key={Util.uid()} width={330} style={{ cursor: "pointer" }} alt="Picture" src={url} onClick={openImgInNewWindow.bind(null, url)} />);
   }
   return jsx;
}

//Show photo in new browser window.
function openImgInNewWindow(url: string) {
   window.open(url, "Picture");
}

//Default map tip.
export function getDefault(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];
   let i: number = 0;

   const styles: Default.iStyles = {
      default: { fontWeight: 500 },
   };

   for (const field of fields) {
      if (Settings.security.accessLevel >= field.accessLevel) {
         if (field.value !== "") {
            if (i > 0) {
               jsx.push(<span key={Util.uid()}>&nbsp;&nbsp;&nbsp;</span>);
            }
            jsx.push(<Typography key={Util.uid()} style={styles.default} variant="body2">{field.value}</Typography>);
            i++;
         }
      }
   }
   return jsx;
}
